import React from "react";

export const LicenseRenewalSubscriptionContext = React.createContext();